/**
 * Cards Hierarchy - Determines banner visibility rules based on app mode
 */

import { getCurrentMode as getAppMode } from '../app-mode-manager.js';

/**
 * Gets the current app mode
 * @returns {string} Current mode
 */
export function getCurrentMode() {
    return getAppMode();
}

/**
 * Determines if the banner should always be visible for a given mode
 * @param {string} mode - App mode to check
 * @returns {boolean} True if banner should always be visible
 */
export function isBannerAlwaysVisible(mode) {
    // Banner should always be visible in these modes:
    // - favorites: User's favorites should always show cards
    // - explore: Explore mode should show cards
    // - map/discover: Map mode should show cards
    const alwaysVisibleModes = ['favorites', 'myfavorites', 'explore', 'map', 'discover'];
    return alwaysVisibleModes.includes(mode);
}

/**
 * Card Action Button Visibility per Hierarchy Level
 * Controls which action buttons are shown for each card type
 */
export const CARD_ACTIONS_VISIBILITY = {
    spot: {
        share: true,
        favorite: true,
        directions: true
    },
    explore: {
        share: true
    },
    map: {
        share: true
    },
    area: {
        share: false  // Hide share for area cards
    },
    special: {
        share: false
    }
};

/**
 * Get action button visibility for a card type
 * @param {string} cardType - Card type ('spot', 'explore', 'map', 'area', 'special')
 * @returns {Object} Visibility settings for this card type
 */
export function getCardActionsVisibility(cardType) {
    return CARD_ACTIONS_VISIBILITY[cardType] || { share: false };
}

